// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"dd49c714","223":"dd49c714","252":"dd49c714","261":"dd49c714"}[chunkId] + ".chunk.css";
};